import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export function createDriverTourEngine({
  steps,
  options = {},
  onStepChange,
  onCompleted,
  onDismissed,
}) {
  let terminalReason = null;
  const driverInstance = driver({
    allowClose: true,
    overlayClickBehavior: "close",
    showProgress: true,
    showButtons: ["next", "previous", "close"],
    popoverClass: "xbytechat-product-guidance-popover",
    ...options,
    steps,
    onHighlighted(element, step, hookOptions) {
      options.onHighlighted?.(element, step, hookOptions);
      onStepChange?.(hookOptions.index ?? 0);
    },
    onCloseClick(element, step, hookOptions) {
      terminalReason = "dismissed";
      onDismissed?.();
      options.onCloseClick?.(element, step, hookOptions);
      driverInstance.destroy();
    },
    onDoneClick(element, step, hookOptions) {
      terminalReason = "completed";
      onCompleted?.();
      options.onDoneClick?.(element, step, hookOptions);
      driverInstance.destroy();
    },
    onDestroyed(element, step, hookOptions) {
      if (!terminalReason) {
        terminalReason = "dismissed";
        onDismissed?.();
      }
      options.onDestroyed?.(element, step, hookOptions);
    },
  });

  return {
    start() {
      driverInstance.drive();
    },
    stop() {
      terminalReason = terminalReason || "stopped";
      driverInstance.destroy();
    },
    isActive() {
      return driverInstance.isActive();
    },
  };
}
